import React, { useState, useRef } from "react";
import { Line } from "@ant-design/plots";
import axios from "axios";
import html2canvas from "html2canvas"; // Import HTML2Canvas
import api from "../services/api";

const BasinChart = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
  const [basin, setBasin] = useState("");

    const [startYear, setStartYear] = useState("");
    const [startMonth, setStartMonth] = useState("");
    const [endYear, setEndYear] = useState("");
    const [endMonth, setEndMonth] = useState("");

    const chartRef = useRef(null); // Reference for the chart container

    const formatData = (rawData) => {
        return rawData.map((item) => ({
            ...item,
            date: `${item.year}-${String(item.month).padStart(2, "0")}`, // Format as YYYY-MM
        }));
    };

    const fetchGraphData = async (basin,startY, startM, endY, endM) => {
        setLoading(true);
        try {
            const response = await api.get("/graph_data_basin/", {
                params: { basin:basin,start_year: startY, start_month: startM, end_year: endY, end_month: endM },
            });
            setData(formatData(response.data.data));
            setError("");
        } catch (err) {
            setError("Failed to load data.");
            console.error("Error fetching data:", err);
        }
        setLoading(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (basin && startYear && startMonth && endYear && endMonth) {
            fetchGraphData( basin,startYear, startMonth, endYear, endMonth);
        }
    };

    const handlePrint = () => {
        html2canvas(chartRef.current).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const printWindow = window.open("", "_blank");
            printWindow.document.write(`
                <html>
                    <head><title>Print Chart</title></head>
                    <body style="text-align:center;">
                        <img src="${imgData}" style="width:100%; max-width:800px;"/>
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.print();
        });
    };

    const handleDownload = () => {
        html2canvas(chartRef.current).then((canvas) => {
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = "chart.png";
            link.click();
        });
    };
    // const config = {
    //     data,
    //     xField: "year",
    //     yField: "lwe_thickness",
    //     xAxis: { title: { text: "Year" } },
    //     yAxis: { title: { text: "LWE Thickness (cm)" } },
    //     smooth: true,
    //     point: { shape: "circle" },
    //   };
    const config = {
        data,
        xField: "date",
        yField: "lwe_thickness",
        seriesField: "category",
        xAxis: {
            title: { text: "Year-Month" },
            type: "timeCat",
            tickCount: 6,
            label: {
                rotate: -30,
                formatter: (val) => val.replace("-", "/"),
                
            },
        },
        yAxis: {
            title: { text: "LWE Thickness (cm)" },
            min: 0,
        },
       
        smooth: true,
        point: { shape: "point" },
        animation: {
            appear: {
                animation: "path-in",
                duration: 20000,
            },
        },
        interactions: [{ type: "brush" }, { type: "element-highlight" }],
    };

    return (
      <>
       <div style={{ width: "100%",height:'40vh', padding: "5px", maxWidth: "600px", margin: "auto" }}>
    {/* Form for Year and Month Selection */}
    <form 
        onSubmit={handleSubmit} 
        style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "5px",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            borderRadius: "8px",
            boxShadow: "0px 2px 5px rgba(0,0,0,0.1)"
        }}
    >
            <h6>Comparison Data:-</h6><br/>
            
      
        
        <label style={{ display: "flex", flexDirection: "column" }}> 
            Start Year:
            <input 
                type="number" 
                value={startYear} 
                onChange={(e) => setStartYear(e.target.value)} 
                required 
                min="2002"
                max="2024"
                style={{
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                }}
            />
        </label>

        <label style={{ display: "flex", flexDirection: "column" }}> 
            Start Month:
            <select 
                value={startMonth} 
                onChange={(e) => setStartMonth(e.target.value)} 
                required
                style={{
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                }}
            >
                <option value="">Select Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </option>
                ))}
            </select>
        </label>

        <label style={{ display: "flex", flexDirection: "column" }}> 
            End Year:
            <input 
                type="number" 
                value={endYear} 
                onChange={(e) => setEndYear(e.target.value)} 
                required 
                min="2002"
                max="2024"
                style={{
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                }}
            />
        </label>

        <label style={{ display: "flex", flexDirection: "column" }}> 
            End Month:
            <select 
                value={endMonth} 
                onChange={(e) => setEndMonth(e.target.value)} 
                required
                style={{
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                }}
            >
                <option value="">Select Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </option>
                ))}
            </select>
        </label>
        <label style={{ display: "flex", flexDirection: "row" }}>Basin
            <select id="basin" onChange={(e) => setBasin(e.target.value)}
            value={basin} 
            >
          <option value="Awash">Awash</option>
          <option value="Abay">Abay</option>
          <option value="Genalle">Genalle</option>
          <option value="Angereb">Angereb</option>
          <option value="Atbara">Atbara</option>
          <option value="Bilate">Bilate</option>
          <option value="Danakil">Danakil</option>
          <option value="Golina">Golina</option>
          <option value="Mereb11">Mereb</option>
          <option value="Red Sea Coast">Red Sea Coast</option>
          <option value="Shebelle">Shebelle</option>
          <option value="Tekeze">Tekeze</option>
          <option value="Ziway/Abijata">Ziway/Abijata</option>
          <option value="Segen">Segen</option>
          <option value="Omo">Omo</option>
          <option value="Baro">Baro</option>

        </select>
            </label>
        <button 
            type="submit" 
            style={{
                gridColumn: "span 2",
                padding: "10px",
                backgroundColor: "#1890ff",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "background 0.3s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0077cc")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#1890ff")}
        >
            Fetch Data
        </button>
    </form>
     
</div>

            {/* Chart Display */}
            <div className='container'ref={chartRef} style={{ height:'40vh', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
, width: "100%",backgroundColor: "white", padding: "0px" }}>
    {startYear && startMonth && endYear && endMonth && basin &&(
            <p style={{ marginTop: "10px", textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>
                Selected {basin} basin , {startYear} {new Date(0, startMonth - 1).toLocaleString("default", { month: "long" })} 
                {" "} to {endYear} {new Date(0, endMonth - 1).toLocaleString("default", { month: "long" })}
            </p>
        )}
                {loading ? <p>Loading...</p> : error ? <p>{error}</p> : <Line {...config} />}
            </div>
<br/>
          {/* Print & Download Buttons */}
 <div style={{ marginTop: "30px", display: "flex",gap: "10px",float:'right' ,marginRight:'10%'}}>
                <button   style={{
                gridColumn: "span 2",
                padding: "10px",
                backgroundColor: "#1890ff",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "background 0.3s",
            }}
            onClick={handlePrint}>Print Chart</button>
                <button   style={{
                gridColumn: "span 2",
                padding: "10px",
                backgroundColor: "#1890ff",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "background 0.3s",
            }}
            onClick={handleDownload}>Download Chart</button>
            </div>  
        
        </>
    );
};

export default BasinChart;
